import * as React from "react";
const SvgButtonCamera = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewport: "0 0 24 24",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, /* @__PURE__ */ React.createElement("path", { d: "M2.25 9h13.5a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5v-9A1.5 1.5 0 012.25 9zM17.25 17.25l4.987 1.87a.75.75 0 001.013-.7v-6.838a.75.75 0 00-1.013-.7L17.25 12.75v4.5z" }), /* @__PURE__ */ React.createElement("path", { d: "M5.625 13.5a1.874 1.874 0 11.001 3.749 1.874 1.874 0 01-.001-3.749zM12.375 13.5a1.874 1.874 0 11.001 3.749 1.874 1.874 0 01-.001-3.749zM5.625 13.5h6.75M21.75 3H16.5a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75h5.25a1.5 1.5 0 000-3zM15.75 4.5h-1.5a1.5 1.5 0 00-1.5 1.5v3M1.5 6h6A1.5 1.5 0 019 7.5V9" })));
export { SvgButtonCamera as ReactComponent };
